<template>
  <div>
    <div>
      <h2>{{ $t("log.text") }}</h2>
    </div>
    <div class="font-size-11" style="overflow-y: auto;">
      <table class="table table-bordered table-striped">
        <thead class="bg-secondary text-white">
          <tr>
            <th style="width: 1%">
              <b-dropdown split :text="$t('common.select-all')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                <template #button-content>
                  <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                </template>

                <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                  <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                </b-dropdown-item>
                <b-dropdown-item href="#" @click="deleteAll()">
                  <i class="bx bx-trash-alt text-dark" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete-all") }}
                </b-dropdown-item>
              </b-dropdown>
            </th>
            <sortable-table-head field="level" :text="$t('common.level')" :request="request" />
            <sortable-table-head field="title" :text="$t('common.title')" :request="request" />
            <th style="width: 5%">{{ $t("common.request-url") }}</th>
            <sortable-table-head field="module" :text="$t('common.module')" :request="request" />
            <sortable-table-head style="width: 9%" field="causedAccount.name" :text="$t('common.created-by')" :request="request" />
            <sortable-table-head style="width: 7%" field="requestId" :text="$t('common.request-id')" :request="request" />
            <sortable-table-head style="width: 7%" field="requestId" :text="$t('common.request-ip')" :request="request" />
            <th>{{ $t("common.content") }}</th>
            <th>{{ $t("common.detail") }}</th>
            <sortable-table-head field="at" :text="$t('common.at')" :request="request" />
            <th scope="col" style="width: 9%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="filterEnabled">
            <th></th>
            <th>
              <select class="form-control " v-model="levelFilter">
                <option :value="undefined">Tümü</option>
                <option value="INFO">INFO</option>
                <option value="WARNING">WARNING</option>
                <option value="ERROR">ERROR</option>
              </select>
            </th>
            <th><input class="form-control " v-model="titleFilter" /></th>
            <th></th>
            <th><input class="form-control " v-model="moduleFilter" /></th>
            <th><input class="form-control " v-model="accountFilter" /></th>
            <th><input class="form-control " v-model="idFilter" /></th>
            <th></th>
            <th></th>
            <th></th>
            <th>
              <date-picker v-model="rangeDate" range :placeholder="$t('common.date')" @change="setTimeValue" :disabled="isAtLeastOneItemSelected" :lang="lang"> </date-picker>
            </th>
            <th></th>
          </tr>
          <template v-if="pagination">
            <tr v-for="item in pagination.docs" :key="item._id">
              <td>
                <div class="text-center">
                  <b-form-checkbox v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                </div>
              </td>
              <td :class="{ 'text-danger': item.level == 'ERROR', 'text-warning': item.level == 'WARNING' }">
                {{ item.level }}
              </td>
              <td>
                {{ item.title }}
              </td>
              <td>
                <div style="max-width: 500px;max-height: 700px; overflow: auto;">
                  <pre>{{ item.url }}</pre>
                </div>
              </td>
              <td>
                {{ item.module }}
              </td>
              <td>{{ item.causedAccount ? item.causedAccount.name : "" }}</td>
              <td>
                {{ item.requestId }}
              </td>
              <td>
                {{ item.requestIP }}
              </td>
              <td>
                <div style="max-width: 500px;max-height: 700px; overflow: auto;">
                  <pre>{{ item.content }}</pre>
                </div>
              </td>
              <td>
                <div style="max-width: 500px;max-height: 700px; overflow: auto;">
                  <pre>{{ JSON.stringify(item.detail, null, 2) }}</pre>
                </div>
              </td>
              <td>
                {{ item.at | date(true) }}
              </td>
              <td>
                <div class="font-size-16 text-center">
                  <i class="bx bx-trash-alt text-danger hand mr-3" v-b-tooltip.hover :title="$t('common.delete')" @click="deleteById(item)"></i>
                </div>
              </td></tr
          ></template>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />

    <!-- Begin: Pagination -->
    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
const state = "log";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/tr";

export default {
  components: { DatePicker },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { at: "desc" } },
        query: {},
      },
      levelFilter: undefined,
      idFilter: undefined,
      titleFilter: undefined,
      contentFilter: undefined,
      moduleFilter: undefined,
      accountFilter: undefined,
      filterEnabled: false,
      selectedItems: [],
      rangeDate: [],
      level: undefined,
      lang: "tr",
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },

    levelFilter(n, o) {
      if (!n) {
        delete this.request.query.level;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        level: { value: n },
      };
    },
    idFilter(n, o) {
      if (!n) {
        delete this.request.query.requestId;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        requestId: { value: n },
      };
    },

    titleFilter(n, o) {
      if (!n) {
        delete this.request.query.title;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        title: { value: n },
      };
    },
    contentFilter(n, o) {
      if (!n) {
        delete this.request.query.content;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        content: { value: n },
      };
    },
    rangeDate(n, o) {
      const startTime = n[0];
      const endTime = n[1];
      if (!n || startTime == null || endTime == null) {
        delete this.request.query.at;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        at: { value: { $gt: startTime, $lt: endTime }, isObject: true },
      };
    },
    moduleFilter(n, o) {
      if (!n) {
        delete this.request.query.at;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        module: { value: n },
      };
    },
    accountFilter(n, o) {
      if (!n) {
        delete this.request.query["causedAccount.name"];
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        "causedAccount.name": { value: n },
      };
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
  },
  methods: {
    init() {
      this.$store.dispatch(`${state}/paginate`, this.request);
      this.selectedItems = [];
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, item._id);
        this.init();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();
      }
    },

    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/multipleDelete`, selectedItems);
        this.init();
        this.$toast.success("'" + this.$options.filters.translate(this.$t("common.delete-successful")));
      } catch (error) {
        console.error(error);
      }
    },
    async deleteAll() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/deleteAll`);
        this.$toast.success("'" + this.$options.filters.translate(this.$t("common.delete-successful")));
        this.init();
      } catch (error) {
        console.error(error);
      }
    },
    setTimeValue(item) {
      this.rangeDate = item;
    },
  },
};
</script>
